// extracted by mini-css-extract-plugin
module.exports = {"Root":"InputSketch_Root__2oGpQ","View":"InputSketch_View__3ICD9","Component":"InputSketch_Component__eTA7R"};